import React from 'react'
import { Dialog ,Mask } from 'react-weui'
import {connect} from 'react-redux'
import axios from 'axios'
import { renderMoney } from '../utils';
import { encode64 } from '../utils/base64'
import { browserHistory } from 'react-router'
import { Page } from '../components'
import '../css/page/FreeLectureCard.css'

class FreeLectureCard extends React.Component {
    constructor() {
        super()
        this.lecture_id = browserHistory.getCurrentLocation().query.lecture_id
        this.user_id = browserHistory.getCurrentLocation().query.user_id
        this.mode = this.user_id ? 'receive' : 'send'  //  mode 定义两种模式 send 赠送 receive 获得
        this.state = {
            showMask:false,
            lectureInfo:{},
            share_info:{},
            UserSubscribed:'',
            noSubscribedQRcodeUrl:'',
            shareLectureDialog:false,
            source_account_info:{},
            account_info:'',
            acceptStatus:null,
            shareLecture:{
                title: '长按扫码关注 接收赠课通知',
                buttons: [
                    {
                        label: '关闭',
                        onClick: this.hideDialog.bind(this)
                    }
                ]
            }
        }
        this.sendLecturetoFriend = this.sendLecturetoFriend.bind(this)
        this.immediatelyListen = this.immediatelyListen.bind(this)
    }

    componentDidMount() {
        document.title = '赠一得一';
        if(this.mode === 'send'){
            this.fetchShareInfo(this.lecture_id)
        }else{
            this.fetchAcceptInfo(this.user_id,this.lecture_id)
        }
    }

    //获取基础分享信息
    fetchShareInfo(lecture_id) {
        axios.get(`/api/freezone/${lecture_id}/share`).then((res) => {
            if(res.data.code === 0) {
                this.setState({
                    lectureInfo:res.data.data.lecture_info,
                    account_info:res.data.data.account_info,
                    acceptStatus:res.data.data.code,
                    UserSubscribed:res.data.data.account_info.subscribed
                },()=> {
                    let new_share_info = {
                        account_img: res.data.data.account_info.small_avatar_url
                    }
                    if(!res.data.data.account_info.subscribed){
                        //如果是未关注用户，需要调用回调出现二维码
                        this.initShare(res.data.data.account_info,new_share_info,lecture_id)
                    }else{
                        this.initShare(res.data.data.account_info,new_share_info,lecture_id)
                    }
                })
            }
        })
    }

    //初始化分享
    initShare(account_info,share_info,lecture_id,needCb) {
        const changeBase64Avatar = encode64(share_info.account_img)
        this.props.dispatch({
            type: 'UPDATE_SHARE_DATA',
            payload: {
                title: `${account_info.nickname}送给你一节课程，立即领取!`,
                desc: `这次我是认真的，我们一起学习吧!`,
                imgUrl: `https://api.weike.fm/media/image/get_play_thumbnail/${changeBase64Avatar}`,
                type: 'link',
                link: `${window.location.origin}/specials/freeCard?lecture_id=${lecture_id}&user_id=${account_info.id}`,
                successCallback: () => {
                    this.setMask(false)
                }
            }
        })
    }

    //获取可赠送情况
    fetchAcceptInfo(user_id,lecture_id) {
        if(user_id){
            axios.get(`/api/freezone/${lecture_id}/can_accept?sc=${user_id}`).then((res) => {
                if(res.data.code===0) {
                        this.setState({
                            acceptStatus: res.data.data.code,
                            lectureInfo:res.data.data.lecture_info,
                            source_account_info:res.data.data.source_account_info,
                        })
                        //如果没有关注
                        if(res.data.data.qrcode_url){
                            this.setState({
                                UserSubscribed:false,
                                noSubscribedQRcodeUrl:res.data.data.qrcode_url,
                            })
                        }else{
                            //如果可以领取
                            if(res.data.data.code === 0){
                                this.autoFetchLecture(res.data.data.source_account_info)
                            }
                            this.setState({
                                UserSubscribed : true
                            })
                        }

                        //如果没有领取分享的情况
                        let new_account_info = {
                            id: user_id
                        }
                        let new_share_info = {
                            account_img: res.data.data.source_account_info.small_avatar_url
                        }
                        this.initShare(new_account_info,new_share_info,lecture_id)
                 }
            })
        }
    }

    //自动获得赠课
    autoFetchLecture(account_info) {
        let formData = new FormData()
        formData.append('sc', this.user_id)
        formData.append('account_id', account_info.id)
        formData.append('lecture_id', this.lecture_id)
         axios.post(`/api/freezone/${this.lecture_id}/accept`, formData).then((res) => {
            if (res.data.code === 0) {
                this.setState({
                    acceptStatus: res.data.data.code,
                })
                //领取成功分享的情况
                if(res.data.data.code ===0 ){
                    let new_share_info = {
                        account_img: res.data.data.account_info.small_avatar_url
                    }
                    this.initShare(res.data.data.account_info,new_share_info,this.lecture_id)
                }
            }
        })
    }

    //人数转化为x万人
    renderLearnNum(num) {
        if(String(num).length>4) {
            return (num / 10000).toFixed(2) + '万'
        }else {
            return num
        }
    }

    hideDialog() {
        this.setState({
            shareLectureDialog: false
        })
    }

    //分享课程
    sendLecturetoFriend() {
        this.setMask(true)
    }

    //立即听课
    immediatelyListen() {
        window.location.assign(`${window.location.origin}/lecture/${this.lecture_id}?inviter_id=43611144&st=index_free`)
    }

    //分享蒙层
    setMask(status) {
        if(status){
            this.setState({
                showMask: true
            })
        }else{
            this.setState({
                showMask: false
            })
        }
    }


    render() {
        const {lectureInfo, account_info , UserSubscribed , source_account_info ,noSubscribedQRcodeUrl} = this.state
        return (
            <Page>
                {/*弹出关注二维码*/}
                { JSON.stringify(account_info.qrcode_url)!=='{}' &&
                <div className="freeLecturePage-share-dialog">
                    <Dialog type="ios" title={this.state.shareLecture.title} buttons={this.state.shareLecture.buttons}
                            show={this.state.shareLectureDialog}>
                        <div className="share-dialog-qrcode">
                            <img src={account_info.qrcode_url} alt=""/>
                        </div>
                    </Dialog>
                </div>}

                {/*分享蒙窗*/}
                {/*<div className="shareToYourFriendsModal">*/}
                    {/*{this.state.showMask &&*/}
                        {/*<div onClick={()=>this.setMask(false)}>*/}
                            {/*<Mask/>*/}
                            {/*<img className="modalImg" src="https://static-1253442168.image.myqcloud.com/picture/8173011_a7278ff7107d5be28760e9475ba654af.jpg" alt=""/>*/}
                            {/*<div className="tipText-area">*/}
                                {/*<img className="tipText" src="https://static-1253442168.image.myqcloud.com/picture/8173011_8c4fa6e0c9d3851d27cf14c1fbdece9f.jpg" alt=""/>*/}
                            {/*</div>*/}
                        {/*</div>*/}
                    {/*}*/}
                {/*</div>*/}

                <div className="FreeLectureCardPage">
                    <div className="FreeLectureCard-area">
                        <div className="card-content-area">
                            {JSON.stringify(lectureInfo)!=='{}' &&
                                <div className="lecture-page-content">
                                    <img src={lectureInfo.cover_url} alt=""/>
                                    <div className="card-content-title">{lectureInfo.name}</div>
                                    <div className="freeLecture-card-num">
                                    <div className="freeLecture-card-learnNum"><span>{this.renderLearnNum(lectureInfo.popular)}</span>人在学</div>
                                    <div><i className="freeLecture-card-origin-price">原价¥ {renderMoney(lectureInfo.money)}</i></div>
                                </div>
                            </div>}

                            {/*用户赠课*/}
                            { this.mode ==='send' && this.state.acceptStatus!==1 &&
                            <div>
                                <div className="freeLecture-card-bottom-text">
                                    赠课给好友<br/>你也能免费听<br/>赠课结果在公众号通知你
                                </div>
                                <div className="freeLecture-card-bottom-btn" onClick={this.sendLecturetoFriend}>
                                    赠送给好友
                                </div>
                            </div>}

                            {/*5: '如果用户领取自己发的课程'*/}
                            { this.mode ==='receive' &&  this.state.acceptStatus === 5 && UserSubscribed=== true &&
                            <div>
                                <div className="freeLecture-card-bottom-text">
                                    赠课给好友<br/>你也能免费听<br/>赠课结果在公众号通知你
                                </div>
                                <div className="freeLecture-card-bottom-btn" onClick={this.sendLecturetoFriend}>
                                    赠送给好友
                                </div>
                            </div>}

                            {/*2：'用户已领取过当前课程'* 3: '用户未关注，且领取过当前课程'*/}
                            { this.mode ==='receive' && [2,3].indexOf(this.state.acceptStatus) > -1 && UserSubscribed=== true &&
                            <div>
                                <div className="freeLecture-card-bottom-text">
                                    恭喜你 <br/>已免费获得此课程
                                </div>
                                <div className="freeLecture-card-bottom-btn" onClick={this.immediatelyListen}>
                                    立即听课
                                </div>
                            </div>}

                            {/*1: '用户已购买过该课程或者专栏*/}
                            { this.state.acceptStatus === 1 &&
                            <div>
                                <div className="freeLecture-card-bottom-text">
                                    你已购买过此课程 <br/>可直接听课
                                </div>
                                <div className="freeLecture-card-bottom-btn" onClick={this.immediatelyListen}>
                                    立即听课
                                </div>
                            </div>}

                            {/*4: '用户已领取过课程'*/}
                            { this.mode ==='receive' && this.state.acceptStatus === 4 && UserSubscribed=== true  &&
                            <div>
                                <div className="freeLecture-card-bottom-text">
                                    你已获赠其他课程<br/>赠送此课给新用户<br/>你也能免费听此课
                                </div>
                                <div className="freeLecture-card-bottom-btn" onClick={this.sendLecturetoFriend}>
                                    赠送给好友
                                </div>
                            </div>}

                            {/*扫描二维码 获课的时候才用*/}
                            { this.mode==='receive' && source_account_info && UserSubscribed=== false   &&
                            <div className="freeLecture-card-bottom-qrcode">
                                <div className="freeLecture-card-bottom-text">
                                    <div className="freeLecture-card-username">{source_account_info.nickname}</div>
                                    赠送你一门课程<br/>长按扫码关注听课
                                </div>

                                <div className="freeLecture-card-qrcode-area" style={{backgroundImage: `url(${noSubscribedQRcodeUrl})`}}>
                                    <img src={noSubscribedQRcodeUrl} alt=""/>
                                </div>
                            </div>}

                        </div>

                        { this.mode==='receive' && source_account_info &&  UserSubscribed=== false  &&
                        <div className="freeLecture-card-finger">
                            <img
                                src="https://static-1253442168.image.myqcloud.com/picture/8173011_5da813979a7fb2bba5f5b666733815c9.jpg"
                                alt=""/>
                        </div>}
                        {/*扫描二维码 / 按压指纹*/}
                    </div>
                </div>
            </Page>
        )
    }
}


export default connect(state => ({}))(FreeLectureCard)



// WEBPACK FOOTER //
// ./src/pages/FreeLectureCard.js